var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "price-table--feature-content-price" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.authLoaded && !_vm.isLoggedIn
      ? _c(
          "div",
          { staticClass: "price-table--feature-content-price-buy" },
          [
            _c("Button", {
              attrs: { text: "Los geht's", href: _vm.buyButtonLink }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "price-table--feature-content-price-free-info" }, [
      _vm._v("\n\t\tDu bezahlst erst bei der ersten Kontaktierung!\n\t")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "price-table--feature-content-price-inner" },
      [
        _c("div", { staticClass: "price-table--feature-content-price-title" }, [
          _vm._v("Gratis")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "price-table--feature-content-price-info" }, [
          _vm._v("Einfach testen!"),
          _c("br"),
          _vm._v(" ")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }